import React, {Component} from 'react';
import { Icon } from "semantic-ui-react";
import PropTypes from 'prop-types';

class Actividad extends Component{

	constructor(props){
		super(props);
		this.rol = props.rol;
		this.nombre = props.nombre;
		this.categoria = props.categoria;
		this.pagarpor = props.pagarpor;
		this.precioMin = props.precioMin;
		this.precioMid = props.precioMid;
		this.precioMax = props.precioMax;
		this.frecuencia = props.frecuencia;
		this.actID = props.actID;
	}
	botones = (id) => {
		console.log(this.rol)
		if(this.rol === 'admin'){
            return (
				<button
					className='borrar'
					onClick={() => this.props.editarAct(id)}>
					<Icon name='trash alternate' />
				</button>
			)
        }
	}
	editarAct = (id) => {
		this.props.removeAct(id);
	}

	render(){
		return (
			<>
				<td> {this.nombre} </td>
				{/*<td> {this.categoria} </td>*/}
				<td> ${this.precioMin} </td>
				<td> ${this.precioMid} </td>
				<td> ${this.precioMax} </td>
				<td> {this.pagarpor} </td>
				<td> {this.botones(this.actID)} </td>
			</>
		);
	}
}

Actividad.propTypes = {
	actNombre: PropTypes.string
}

export default Actividad;